module.exports = __webpack_public_path__ + "static/media/herobg_94by77.24fbd4cf.jpg";